import $ from 'jquery';

const hightLightAlert = ($item) => {
	$item.addClass('-alert').delay(1500).queue(() => {
		$item.removeClass('-alert').dequeue();
	});
};

const validateContactForm = () => {
	let complete = true;

	$('.contact-form').find('.item').each((i, item) => {
		if ($(item).val() === '' || $(item).val() === '0') {
			hightLightAlert($(item));
			complete = false;
		}
	});

	return complete;
};

export default validateContactForm;



// WEBPACK FOOTER //
// ./src/js/validateContactForm.js